import {CANDIDATE_ACTIVATION_PENDING, 
        CANDIDATE_ACTIVATION_SUCCESS, 
        CANDIDATE_ACTIVATION_FAILURE} from '../actions/accountActions';
import moment from 'moment';

const init = {
    loading: false,
    lastRequestTime: moment.utc().unix(),
    inError: false,
    status: ""
    
}
export default (state=init, action) => { 
    switch(action.type) {
    
    case CANDIDATE_ACTIVATION_PENDING:
            return {...state, loading: true, success:false, inError: false, lastRequestTime: moment.utc().unix()};

    case CANDIDATE_ACTIVATION_SUCCESS:
            return {...state, loading: false, success: true, inError: false, lastRequestTime: moment.utc().unix() };

    case CANDIDATE_ACTIVATION_FAILURE:
            return {...state, loading: false, success: false, inError: true, lastRequestTime: moment.utc().unix() };
        default: return {...state}
    }
}